import { render } from "./PersonaFisica.vue?vue&type=template&id=20c1a3b4"
import script from "./PersonaFisica.vue?vue&type=script&lang=js"
export * from "./PersonaFisica.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francescoscialacqua/Sviluppo/emmet.client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__